import React, { useState } from "react";
import SelectInput from "./select";
import GoogleFonts from "./gfonts.json";
import classnames from "classnames";
import MultipleSelect from "./multipleselect";
import Notice from "./notice";
import { flattenArrayOfMultiselect } from "../utils";

function ProjectFontPicker({
  value,
  onChange,
  className,
  options,
  label = "",
}) {
  const [selectedTarget, setSelectedTarget] = useState("");
  const [selectedFontFamily, setSelectedFontFamily] = useState("");
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [selectedSubsets, setSelectedSubsets] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  const resetStates = () => {
    setSelectedFontFamily("");
    setSelectedTarget("");
    setSelectedSubsets([]);
    setSelectedVariants([]);
    setIsAdding(false);
  };

  const addFont = () => {
    onChange({
      ...value,
      [selectedTarget]: {
        family: selectedFontFamily,
        variants: flattenArrayOfMultiselect(selectedVariants),
        subsets: flattenArrayOfMultiselect(selectedSubsets),
      },
    });
    resetStates();
  };

  if (value === null || value === undefined) {
    value = {};
  }

  const classes = classnames(
    "grigora-project-font-picker  text-grigora-base select-none  flex  flex-col mb-2",
    className,
  );

  return (
    <div className={classes}>
      {isAdding ? (
        <>
          <div className="red">
            <SelectInput
              isResetVisible={false}
              options={[
                { label: "Select a target", value: "" },
                { label: "Body", value: "body" },
                { label: "Headings", value: "h*" },
                { label: "H1", value: "h1" },
                { label: "H2", value: "h2" },
                { label: "H3", value: "h3" },
                { label: "H4", value: "h4" },
                { label: "H5", value: "h5" },
                { label: "H6", value: "h6" },
                { label: "Site Title", value: "site-title" },
                { label: "Buttons", value: "buttons" },
              ]}
              value={selectedTarget}
              onChange={(val) => setSelectedTarget(val)}
            />
          </div>

          <SelectInput
            isResetVisible={false}
            options={[{ label: "Select a font", value: "" }].concat(
              Object.keys(GoogleFonts).map((item) => {
                return {
                  label: item,
                  value: item,
                };
              }),
            )}
            value={selectedFontFamily}
            onChange={(val) => {
              setSelectedFontFamily(val);
              setSelectedVariants([]);
              setSelectedSubsets([]);
            }}
          />

          {selectedFontFamily &&
          selectedTarget &&
          GoogleFonts[selectedFontFamily] ? (
            <>
              {" "}
              <Notice
                text="Select variants you want to import. By default, only the regular 400 variant is imported. Importing bold variants might be a good idea for bolder headings."
                status="info"
              />
              <MultipleSelect
                isResetVisible={false}
                value={selectedVariants}
                onChange={(val) => setSelectedVariants(val)}
                options={GoogleFonts[selectedFontFamily].variants.map(
                  (item) => {
                    return {
                      label: item,
                      value: item,
                    };
                  },
                )}
              />
              <br />
              <MultipleSelect
                isResetVisible={false}
                value={selectedSubsets}
                onChange={(val) => setSelectedSubsets(val)}
                options={GoogleFonts[selectedFontFamily].subsets.map((item) => {
                  return {
                    label: item,
                    value: item,
                  };
                })}
              />
              <div className="flex  items-center mt-3">
                <div className="mr-2">
                  <button
                    onClick={() => resetStates()}
                    className="px-3 text-center py-1 text-blue-600 hover:text-white hover:bg-blue-700 border-2 border-blue-600 hover:border-blue-700   rounded font-semibold cursor-pointer"
                  >
                    Cancel
                  </button>
                </div>
                <div className="">
                  <button
                    onClick={() => addFont()}
                    className="px-3 text-center py-1 text-blue-600 hover:text-white hover:bg-blue-700 border-2 border-blue-600 hover:border-blue-700   rounded font-semibold cursor-pointer"
                  >
                    Add
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </>
      ) : (
        <div className="">
          <button
            onClick={() => setIsAdding(true)}
            className="px-3 text-center py-1 text-blue-600 hover:text-white hover:bg-blue-700 border-2 border-blue-600 hover:border-blue-700  rounded font-semibold cursor-pointer"
          >
            + Add font
          </button>
        </div>
      )}
    </div>
  );
}

export default ProjectFontPicker;
